import { ApolloProvider } from '@apollo/client';
import { LinkingOptions } from '@react-navigation/native';

import Navigation from './navigator';
import { unauthenticatedClient } from '../../api/apollo';

interface Props {
	linkingConfiguration?: LinkingOptions<ReactNavigation.RootParamList>;
}

export const UnauthenticatedApp = ({ linkingConfiguration }: Props) => {
	return (
		<ApolloProvider client={unauthenticatedClient}>
			<Navigation linking={linkingConfiguration} />
		</ApolloProvider>
	);
};
